import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import { PrivacyProvider } from "@/context/PrivacyContext";
import { PortfolioProvider } from "@/context/PortfolioContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import ErrorBoundary from "@/components/ErrorBoundary";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import Holdings from "@/pages/Holdings";
import Watchlist from "@/pages/Watchlist";
import SecurityDetail from "@/pages/SecurityDetail";
import MetricDetail from "@/pages/MetricDetail";
import Transactions from "@/pages/Transactions";
import Performance from "@/pages/Performance";
import Dividends from "@/pages/Dividends";
import AIAnalyst from "@/pages/AIAnalyst";
import Settings from "@/pages/Settings";
import Tax from "@/pages/Tax";
import Parameters from "@/pages/Parameters";
import Issues from "@/pages/Issues";
import Reconcile from "@/pages/Reconcile";
import CorporateActions from "@/pages/CorporateActions";

const App = () => {
    const Protected = ({ children }) => (
        <ProtectedRoute>
            <PortfolioProvider><Layout><ErrorBoundary>{children}</ErrorBoundary></Layout></PortfolioProvider>
        </ProtectedRoute>
    );
    return (
        <ThemeProvider>
            <AuthProvider>
                <PrivacyProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/accept-invite" element={<AcceptInvite />} />
                        <Route path="/" element={<Protected><Dashboard /></Protected>} />
                        <Route path="/holdings" element={<Protected><Holdings /></Protected>} />
                        <Route path="/watchlist" element={<Protected><Watchlist /></Protected>} />
                        <Route path="/watchlist/:ticker" element={<Protected><SecurityDetail watchlist /></Protected>} />
                        <Route path="/security/:ticker" element={<Protected><SecurityDetail /></Protected>} />
                        <Route path="/metric/:key" element={<Protected><MetricDetail /></Protected>} />
                        <Route path="/transactions" element={<Protected><Transactions /></Protected>} />
                        <Route path="/performance" element={<Protected><Performance /></Protected>} />
                        <Route path="/dividends" element={<Protected><Dividends /></Protected>} />
                        <Route path="/ai" element={<Protected><AIAnalyst /></Protected>} />
                        <Route path="/settings" element={<Protected><Settings /></Protected>} />
                        <Route path="/tax" element={<Protected><Tax /></Protected>} />
                        <Route path="/issues" element={<Protected><Issues /></Protected>} />
                        <Route path="/reconcile" element={<Protected><Reconcile /></Protected>} />
                        <Route path="/corporate-actions" element={<Protected><CorporateActions /></Protected>} />
                        <Route path="/parameters" element={<Protected><Parameters /></Protected>} />
                    </Routes>
                </BrowserRouter>
                </PrivacyProvider>
                <Toaster position="top-right" richColors />
            </AuthProvider>
        </ThemeProvider>
    );
};

export default App;
